import { AxiosResponse } from 'axios';
import { call, put, takeLatest, select } from 'redux-saga/effects';

import {
  GET_COMPANY,
  GET_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
  GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS,
  GET_QUOTAS,
} from '../constants/ActionTypes';
import {
  getCompanyApi,
  getCompanyTeamMembersStatsApi,
  getQuotasApi,
} from '../api/auth.api';
import { DO_CENTRAL_SERVICE_URL } from '../constants/AppConstants';
import { IInitialState } from '../types/initialState.types';

function* getCompany() {
  const { org, username } = yield select(
    (state: IInitialState) => state.auth.userIdentityData
  );
  try {
    const getCompanyResp: AxiosResponse = yield call(
      getCompanyApi,
      org,
      username
    );
    if (getCompanyResp && getCompanyResp?.data) {
      yield put({
        type: `${GET_COMPANY}_SUCCESS`,
        payload: getCompanyResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  }
}

function* getQuotas() {
  const { username } = yield select(
    (state: IInitialState) => state.auth.userIdentityData
  );
  try {
    const getQuotasResp: AxiosResponse = yield call(getQuotasApi, username);
    if (getQuotasResp && getQuotasResp?.data) {
      yield put({
        type: `${GET_QUOTAS}_SUCCESS`,
        payload: getQuotasResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  }
}

function* getCompanyTeamMembersStats() {
  const { username } = yield select(
    (state: IInitialState) => state.auth.userIdentityData
  );
  try {
    const getCompanyTeamMembersStatsResp: AxiosResponse = yield call(
      getCompanyTeamMembersStatsApi,
      username
    );
    if (
      getCompanyTeamMembersStatsResp &&
      getCompanyTeamMembersStatsResp?.data
    ) {
      yield put({
        type: GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS,
        payload: getCompanyTeamMembersStatsResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  }
}

export default function* loadAuthSaga() {
  yield takeLatest(GET_COMPANY, getCompany);
  yield takeLatest(GET_QUOTAS, getQuotas);
  yield takeLatest(
    GET_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
    getCompanyTeamMembersStats
  );
}
